import { createAsyncThunk } from '@reduxjs/toolkit';
import { assertError } from './asserts/assertError';
import { EType } from '../../repositories/sms/entities/PublicValidationCode/PublicSendValidationCodeRequest';
import { fetchSendValidationCode, TSendValidationCodeResponse } from '../../repositories/sms/v2/send-validation-code';
import { setPhoneValidation } from '../../slices/pageState';
import {
  setPhoneConfirmationRequestFailure,
  setPhoneConfirmationRequestSubmitting,
  setPhoneConfirmationRequestSuccess,
} from '../../slices/phoneConfirmation';
import { IThunkApi } from '../../types/redux/store';

interface IRequestPhoneValidationCodeParams {
  phone: string;
}

interface IThunkApiExtended extends IThunkApi {
  rejectValue: void;
}

export const requestPhoneValidationCode = createAsyncThunk<void, IRequestPhoneValidationCodeParams, IThunkApiExtended>(
  'phoneValidationCode/requestPhoneValidationCode',
  async (parameters, { extra: context, dispatch }) => {
    const { httpApi } = context;

    const { phone } = parameters;

    dispatch(setPhoneConfirmationRequestSubmitting());
    try {
      const response: TSendValidationCodeResponse = await fetchSendValidationCode({
        httpApi,
        parameters: { phone, type: EType.NewBuildingCallbackForm },
      });

      assertError(response);

      dispatch(setPhoneValidation());

      dispatch(setPhoneConfirmationRequestSuccess({ secondsToRetry: response.response.secondsToRetry || 0 }));
    } catch (error) {
      let errorText = '';
      let secondsToRetry = 0;

      if (error.errors?.phoneNumberIsInvalid) {
        errorText = error.errors.phoneNumberIsInvalid;
        secondsToRetry = 0;
      }
      if (error.errors?.tryValidationCodeLater) {
        dispatch(setPhoneValidation());
        errorText = error.errors.tryValidationCodeLater;
        secondsToRetry = 0;
      }

      dispatch(setPhoneConfirmationRequestFailure({ error: errorText, secondsToRetry }));
    }
  },
);
